import axios from 'axios';

const SubmissionService = {
  addOrganisation(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/AddOrganisation`;
    return axios.post(url, json);
  },

  updateOrganisation(ID, json) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/${ID}`;
    return axios.put(url, json);
  },

  deleteOrganisation(Id) {
    const url = `${process.env.REACT_APP_HOST_URL}organisation/${Id}`;
    return axios.delete(url);
  },

  getSubmissions() {
    const url = `${process.env.REACT_APP_HOST_URL}Submission/GetSubmissions`;
    return axios.get(url);
  },

  getOrganisation(ID) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/${ID}`;
    return axios.get(url);
  },

  getScheduleDetails(scheduleId) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetGeneratedScheduleDetails/${scheduleId}`;
    return axios.get(url);
  },

  getSubmissionDetails(scheduleID, channelID) {
    const url = `${process.env.REACT_APP_HOST_URL}Submission/GetGeneratedScoreSubmissions/${scheduleID}?ChannelId=${channelID}`;
    return axios.get(url);
  },

  exportSubmissions(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/ExportSchedule${parameters}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  },

  exportStatistics(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Submission/ExportStatistics${parameters}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  },
  getCalendarDetails(scheduleId, channeId) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetCalendarDetails/${scheduleId}?ChannelId=${channeId}`;
    return axios.get(url);
  },
  async downloadSubmissionExportFile(submissionId) {
    try {
      const url = `${process.env.REACT_APP_HOST_URL}Submission/DownloadExportFile/${submissionId}`;

      const response = await axios.get(url, {
        responseType: 'blob',
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default SubmissionService;
